import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

/**
 * The page is written in the language of the design — Russian. English is a
 * real, selectable language whose copy has to be supplied; until a key is
 * translated it falls back to the Russian the design specifies, so nothing is
 * ever shown in words nobody wrote.
 */
void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: 'ru',
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
});

export const LANGUAGES = [
  { code: 'ru', label: 'Rus' },
  { code: 'en', label: 'Eng' },
] as const;

export default i18n;
